import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class IcalModel extends Model {
  @attr('string') url!: string;

  @belongsTo('property', { inverse: 'ical', async: false })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    ical: IcalModel;
  }
}
